module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-field"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Field")]), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-field', {
    attrs: {
      "label": "用户名",
      "placeholder": "请输入用户名",
      "attr": {
        maxlength: 10
      }
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "邮箱",
      "placeholder": "请输入邮箱",
      "type": "email"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "密码",
      "placeholder": "请输入密码",
      "type": "password"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "手机号",
      "placeholder": "请输入手机号",
      "type": "tel"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "网站",
      "placeholder": "请输入网址",
      "type": "url"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "数字",
      "placeholder": "请输入数字",
      "type": "number"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "生日",
      "placeholder": "请输入生日",
      "type": "date"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "自我介绍",
      "placeholder": "自我介绍",
      "type": "textarea",
      "rows": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-field', {
    attrs: {
      "placeholder": "登录邮箱",
      "type": "email"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": "密码",
      "type": "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-field', {
    attrs: {
      "label": "邮箱",
      "placeholder": "成功状态",
      "state": "success"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "邮箱",
      "placeholder": "失败状态",
      "state": "error"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "label": "邮箱",
      "placeholder": "警告状态",
      "state": "warning"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part"
  }, [_c('mt-field', {
    attrs: {
      "label": "验证码",
      "placeholder": "输入验证码"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/100x100.png"),
      "height": "48px",
      "width": "100px"
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe6420f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/field.vue
// module id = 289
// module chunks = 0